import { useLocation, useNavigate } from "react-router-dom";
import BackArrowIcon from "../../../components/Icons/BackArrowIcon";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useForm, useFieldArray, Controller } from "react-hook-form";
import { DatePicker } from "rsuite";
import moment from "moment";
import ErrorMessage from "../../../components/comman/ErrorMessage";
import { Spinner } from "reactstrap";
import PlusIcon from "../../../components/Icons/PlusIcon";
import DeleteIcon from "../../../components/Icons/DeleteIcon";
import SearchSelectInput from "../../../components/comman/SearchSelectInput";
import { errorTypes } from "../../../utility/InputValidation";
import calculateFinancialYears from "../../../utility/CommonFunctions";

export default function CreateStockOut() {
  const navigate = useNavigate();
  const location = useLocation();
  // console.log("location?.state?.data=======>", location?.state?.data);

  const [pageStates, setPageStates] = useState({
    isLoading: false,
    assignedSites: [],
    itemsList: [],
    siteName: "",
    isLoadingSite: false,
    stockOutDetail: {},
  });
  const [financialYears, setFinancialYears] = useState([]);
  const [activeFinancialYear, setActiveFinancialYear] = useState("");

  const {
    register,
    setValue,
    getValues,
    reset,
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const { fields, append, remove } = useFieldArray({
    control,
    name: "item",
  });

  useEffect(() => {
    if (fields.length === 0) {
      append({ itemId: "", quantity: "", expenseHeadId: "" });
    }
  }, [fields, append]);

  useEffect(() => {
    if (location?.state?.data) {
      const locationData = location.state.data;

      let options = {
        method: "GET",
      };
      let API =
        apiUrl?.get_stock_out_detail + `?stockOutId=${locationData?.id}`;
      // setIsLoading(true);
      callApi(API, options).then((response) => {
        // setIsLoading(false);
        if (response?.status === true) {

          setPageStates((prev) => ({
            ...prev,
            stockOutDetail: response?.data,
            siteName: response?.data.site?.name,
          }));

          const itemPromise = GetItemsList(response?.data.siteId, activeFinancialYear || response?.data?.financialYear);

          Promise.resolve(itemPromise).then(() => {
            const formattedItems = response?.data?.StockOutItems?.map((item) => ({
              itemId: item?.item?.id,
              quantity: item?.quantity,
              expenseHeadId: item?.expenseHeadId || "",
            }));

            reset({
              siteId: response?.data.site?.id,
              date: moment(response?.data?.date).format("YYYY-MM-DD"),
              type: response?.data?.type,
              item:
                formattedItems.length > 0
                  ? formattedItems
                  : [{ itemId: "", quantity: "", expenseHeadId: "" }],
            });
          });

          if (response?.data?.site) {
            handleFinancialYearCalculation(response.data.site);
          }
        } else {
          toast.error(response?.message);
        }
      });
    }
  }, []);

  useEffect(() => {
    getAssignedSites();
  }, []);

  const getAssignedSites = (inputValue = null) => {
    const option = { method: "GET" };
    const url = `${apiUrl?.get_user_site}${inputValue ? `?search=${inputValue}` : ""
      }`;
    callApi(url, option).then((res) => {
      if (res?.status === true) {
        setPageStates((prev) => ({
          ...prev,
          assignedSites: res?.data?.site?.map((item) => ({
            ...item,
            label: item?.site?.name,
            value: item?.site?.id,
          })),
        }));
      } else {
        toast.error(res?.message);
      }
    });
  };



  const handleFinancialYearCalculation = (siteData) => {
    const startDate = siteData?.startDate;
    const endDate = siteData?.endDate;

    let fyStartYear;
    const now = moment();
    const month = now.month() + 1;
    const year = now.year();

    if (!startDate || !endDate) {
      fyStartYear = month >= 4 ? year : year - 1;
      const currentFY = `${fyStartYear}-${fyStartYear + 1}`;
      setFinancialYears([currentFY]);
      setActiveFinancialYear(currentFY);
      return;
    }

    const fys = calculateFinancialYears(
      moment.utc(startDate).format("YYYY-MM-DD"),
      moment.utc(endDate).format("YYYY-MM-DD")
    );

    setFinancialYears(fys);

    fyStartYear = month >= 4 ? year : year - 1;
    const currentFY = `${fyStartYear}-${fyStartYear + 1}`;

    const selectedFY = fys.includes(currentFY) ? currentFY : fys[0] || "";

    // Set active financial year
    // If editing, we might want to respect existing data if available, but for now defaulting to calculation or existing
    if (location?.state?.data?.financialYear) {
      setActiveFinancialYear(location?.state?.data?.financialYear)
    } else {
      setActiveFinancialYear(selectedFY);
    }
  };

  const GetItemsList = (siteId, financialYear) => {
    if (!siteId || !financialYear) return Promise.resolve(null);
    const option = { method: "GET" };
    const url = apiUrl?.get_grn_item + `siteId=${siteId}&financialYear=${financialYear}`;
    return callApi(url, option).then((res) => {
      if (res?.status === true) {
        setPageStates((prev) => ({
          ...prev,
          itemsList: res?.data,
        }));
        return res;
      } else {
        toast.error(res?.message);
        return res;
      }
    });
  };

  const watchedItems = watch("item") || [];

  const getSelectedItemIds = () => {
    return watchedItems.map((item) => item?.itemId?.toString()).filter(Boolean);
  };

  const onSubmit = (data) => {
    const postData = {
      siteId: data.siteId,
      date: data.date,
      type: data?.type,

      item: data?.item,
      financialYear: activeFinancialYear,
    };
    // console.log("postData======>", postData);

    const isUpdate = location?.state?.data;
    const api = isUpdate
      ? `${apiUrl.update_stock_out}?stockOutId=${location?.state?.data?.id}`
      : apiUrl.create_stock_out;

    let options = {
      method: "POST",
      data: postData,
    };

    setPageStates((prev) => ({
      ...prev,
      isLoading: true,
    }));
    callApi(api, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        isLoading: false,
      }));
      if (response?.status === true) {
        toast.success(
          response?.message ||
          `Stock Out ${isUpdate ? "Updated" : "Created"} successfully.`
        );
        navigate(-1);
      } else {
        toast.error(response?.message || "Something went wrong.");
      }
    });
  };

  return (
    <>
      <div className="content container-fluid">
        <div className="content-head mb-5 d-flex align-items-start justify-content-between">
          <div className="d-flex align-items-center justify-content-start gap-4">
            <button className="btn back-arrow" onClick={() => navigate(-1)}>
              <BackArrowIcon />
            </button>
            <h1 className="mb-0">
              {location?.state?.data ? "Update" : "Create"} Stock Out Entry
            </h1>
          </div>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <Controller
                      name="siteId"
                      control={control}
                      rules={{ ...errorTypes.required("site") }}
                      render={({ field, fieldState }) => (
                        <SearchSelectInput
                          label="Site"
                          placeholder="Search Site"
                          value={pageStates.siteName}
                          onSelect={(option) => {
                            field.onChange(option?.value);
                            setValue("siteId", option?.value);

                            reset((prevValues) => ({
                              ...prevValues,
                              item: [
                                {
                                  itemId: "",
                                  quantity: "",
                                  expenseHeadId: "",
                                },
                              ],
                            }));

                            const selectedSite = pageStates.assignedSites.find(s => s.site.id === option.value);

                            let newActiveFY = activeFinancialYear;

                            if (selectedSite) {
                              const siteData = selectedSite.site;
                              const startDate = siteData?.startDate;
                              const endDate = siteData?.endDate;

                              let fyStartYear;
                              const now = moment();
                              const month = now.month() + 1;
                              const year = now.year();

                              fyStartYear = month >= 4 ? year : year - 1;
                              const currentFY = `${fyStartYear}-${fyStartYear + 1}`;

                              if (!startDate || !endDate) {
                                newActiveFY = currentFY;
                              } else {
                                const fys = calculateFinancialYears(
                                  moment.utc(startDate).format("YYYY-MM-DD"),
                                  moment.utc(endDate).format("YYYY-MM-DD")
                                );
                                newActiveFY = fys.includes(currentFY) ? currentFY : fys[0] || "";
                              }

                              setActiveFinancialYear(newActiveFY);
                              // Update options
                              handleFinancialYearCalculation(siteData);
                            }

                            GetItemsList(option?.value, newActiveFY);
                          }}
                          onBlur={field.onBlur}
                          errors={fieldState.error?.message}
                          options={pageStates.assignedSites}
                          onSearch={getAssignedSites}
                          isLoading={pageStates?.isLoadingSite}
                          showAddButton={false}
                          required={true}
                          disabled={location?.state?.data}
                        />
                      )}
                    />
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label">Financial Year<span className="text-danger">*</span></label>
                    <select
                      className="form-select"
                      onChange={(e) => {
                        setActiveFinancialYear(e.target.value)
                        const activeSite = getValues("siteId");
                        GetItemsList(activeSite, e.target.value)
                      }}
                      disabled={location?.state?.data}
                      value={activeFinancialYear}
                    >
                      {financialYears?.map((fy) => (
                        <option key={fy} value={fy}>
                          {fy}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label" htmlFor="bDate">
                      Type<span className="text-danger">*</span>
                    </label>
                    <select
                      className={`form-select form-control ${errors?.type ? "is-invalid" : ""
                        }`}
                      {...register(`type`, {
                        required: "Type is required",
                      })}
                    >
                      <option value="">Choose Type</option>
                      <option value="consumed">Consumed</option>
                      <option value="scrap">Scrap</option>
                      <option value="sale">Sale</option>
                    </select>
                    <ErrorMessage message={errors?.type?.message} />
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label" htmlFor="bDate">
                      Date<span className="text-danger">*</span>
                    </label>
                    <Controller
                      name="date"
                      control={control}
                      rules={{
                        required: "This field is Required",
                        validate: (value) => {
                          const checkDate = moment(value).startOf('day');
                          const today = moment().startOf('day');
                          if (checkDate.isAfter(today)) {
                            return "Future dates are not allowed";
                          }
                          return true;
                        }
                      }}
                      defaultValue={moment().format("YYYY-MM-DD")}
                      render={({ field }) => (
                        <DatePicker size="sm"
                          {...field}
                          id="bDate"
                          format="dd/MM/yyyy"
                          oneTap
                          placeholder="dd/mm/yyyy"
                          style={{ width: "100%" }}
                          value={field.value ? new Date(field.value) : null}
                          onChange={(date) => {
                            field.onChange(date ? moment(date).format("YYYY-MM-DD") : "");
                          }}
                          shouldDisableDate={(date) => date > new Date()}
                          cleanable={false}
                        />
                      )}
                    />
                    <ErrorMessage message={errors?.date?.message} />
                  </div>
                </div>



                <div className="col-12">
                  <div className="d-flex align-items-center justify-content-between border-bottom mb-4">
                    <h4 className="fs-3 rajdhani-semibold my-4 ">
                      Item Details
                    </h4>
                  </div>

                  <table className="table mt-3">
                    <thead>
                      <tr>
                        <th>Item</th>
                        <th>Quantity</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {fields.map((field, index) => (
                        <tr key={field.id}>
                          <td style={{ width: "50rem" }}>
                            <select
                              className={`form-select form-control ${errors?.item?.[index]?.itemId
                                ? "is-invalid"
                                : ""
                                }`}
                              {...register(`item.${index}.itemId`, {
                                required: "Item is required",
                              })}
                              onChange={(e) => {
                                const selectedId = e.target.value;

                                setValue(`item.${index}.itemId`, selectedId);

                                const selectedItem =
                                  pageStates?.itemsList?.find(
                                    (i) => i.item?.id?.toString() === selectedId
                                  );

                                if (selectedItem?.item?.expenseHeadId) {
                                  setValue(
                                    `item.${index}.expenseHeadId`,
                                    selectedItem?.item?.expenseHeadId
                                  );
                                } else {
                                  setValue(`item.${index}.expenseHeadId`, "");
                                }
                              }}
                            >
                              <option value="">Choose Item</option>

                              {pageStates?.itemsList?.length > 0 ? (
                                pageStates?.itemsList?.map((item) => {
                                  const selectedItemIds = getSelectedItemIds();
                                  const currentItemId =
                                    watchedItems?.[index]?.itemId?.toString();

                                  const isSelected = selectedItemIds.includes(
                                    item?.item?.id?.toString()
                                  );
                                  const isCurrent =
                                    currentItemId ===
                                    item?.item?.id?.toString();

                                  return (
                                    <option
                                      key={item?.item?.id}
                                      value={item?.item?.id}
                                      disabled={!isCurrent && isSelected}
                                    >
                                      {item?.item?.name}
                                    </option>
                                  );
                                })
                              ) : (
                                <option value="" disabled>
                                  No items found
                                </option>
                              )}
                            </select>
                          </td>

                          <td>
                            <input
                              type="number"
                              onWheel={(e) => e.target.blur()}
                              className={`form-control ${errors?.item?.[index]?.quantity
                                ? "is-invalid"
                                : ""
                                }`}
                              placeholder="Enter Quantity"
                              {...register(`item.${index}.quantity`, {
                                required: "Quantity is required",
                                min: 1,
                              })}
                            />
                          </td>

                          <td>
                            <div className="d-flex gap-2">
                              {fields.length > 1 && (
                                <button
                                  type="button"
                                  className="btn btn-outline-danger"
                                  onClick={() => remove(index)}
                                >
                                  <DeleteIcon />
                                </button>
                              )}
                              {index === fields.length - 1 && (
                                <button
                                  type="button"
                                  className="btn btn-outline-primary"
                                  onClick={() => {
                                    const siteId = watch("siteId");

                                    if (!siteId) {
                                      toast.warning(
                                        "Please select a site first."
                                      );
                                      return;
                                    }

                                    if (pageStates?.itemsList?.length === 0) {
                                      toast.info(
                                        "No items available for the selected site."
                                      );
                                      return;
                                    }

                                    const selectedItemIds =
                                      getSelectedItemIds();
                                    const allItemIds =
                                      pageStates?.itemsList?.map((i) =>
                                        i.itemId?.toString()
                                      ) || [];

                                    const unselectedItems = allItemIds.filter(
                                      (id) => !selectedItemIds.includes(id)
                                    );

                                    if (unselectedItems.length === 0) {
                                      toast.info("No more items to select.");
                                      return;
                                    }

                                    append({
                                      itemId: "",
                                      quantity: "",
                                      expenseHeadId: "",
                                    });
                                  }}
                                >
                                  <PlusIcon />
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-end">
                <button
                  disabled={pageStates?.isLoading}
                  type="submit"
                  className="btn btn-primary px-5"
                >
                  {pageStates?.isLoading ? (
                    <Spinner />
                  ) : location?.state?.data ? (
                    "Update"
                  ) : (
                    "Create"
                  )}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
